// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import redirectToSignInSessionTimeout from "@ces/App/Handlers/XNG/RedirectToSignInSessionTimeout";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    PopulateApiParameter as SetShippingPopulateApiParameter,
    chain as SetShippingPopulateApiParameterChain,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetShippingMethod";
import translate from "@insite/client-framework/Translate";

export const XngPopulateApiParameter: typeof SetShippingPopulateApiParameter = props => {
    // XNG-Change add try catch
    try {
        const state = props.getState();
        const { cartId } = state.pages.checkoutReviewAndSubmit;
        const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
        if (!cart) {
            throw new Error("There was no current cart and we are trying to set a shipping method on it.");
        }
        const updatedCart: Cart = {
            ...cart,
            ...props.parameter,
        };
        props.apiParameter = { cart: updatedCart };
    } catch (error) {
        (props.parameter as any).onError?.(
            error.status === 400 ? error.errorJson.message : translate("There is an error please contact support team"),
        );

        props.dispatch(redirectToSignInSessionTimeout({ errorMessage: error.errorJson.message }));
    }
};
replaceInChain(SetShippingPopulateApiParameterChain, SetShippingPopulateApiParameter, XngPopulateApiParameter);
